import { z } from "zod";

export type MessageFile = z.infer<typeof MessageFileSchema>;
export const MessageFileSchema = z.object({
  originalName: z.string(),
  content: z.string(),
  size: z.string(),
});
